import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RouteLinkTab } from '@shared/models';
import { AuthGuardService } from '@shared/services';

import { StorePermission } from './store-permission';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})
export class StoreComponent implements OnInit {
  permission = new StorePermission();
  listRoute: RouteLinkTab[] = [];

  constructor(
    private authGuardService: AuthGuardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setRouteTab();
    if (this.router.url === '/merchant-store/store') {
      this.setRedirectTo();
    }
  }

  setRedirectTo() {
    if (this.permission.hasViewStoreList) {
      this.router.navigate(['/merchant-store/store/store-list']);
    } else if (this.permission.hasViewStoreRequestList) {
      this.router.navigate(['/merchant-store/store/store-request-list']);
    }
  }

  setRouteTab() {
    this.permission.checkPermission(this.authGuardService);

    this.listRoute = [];

    if (this.permission.hasViewStoreList) {
      this.listRoute.push({ tabName: 'Store List', url: '/merchant-store/store/store-list' });
    }

    if (this.permission.hasViewStoreRequestList) {
      this.listRoute.push({ tabName: 'Store Request', url: '/merchant-store/store/store-request-list' });
    }
  }
}
